import axios from "axios";
import { auth } from "./firebase";
import createAuthRefreshInterceptor from "axios-auth-refresh";
import logger from "./logger";

const APP_API_ENDPOINT = process.env.VUE_APP_API_ENDPOINT;

async function getToken(): Promise<string> {
  const user = auth().currentUser;
  if (user) {
    let token = await user.getIdToken(true);
    logger("log", "refreshing token");
    return token;
  }
  return "";
}

async function refreshToken(failedRequest: any): Promise<any> {
  const token = await getToken();
  failedRequest.response.config.headers["Authorization"] = "Bearer " + token;
  return Promise.resolve();
}

async function setToken() {
  const token = await getToken();
  axios.defaults.headers.common["Authorization"] = token;
}

createAuthRefreshInterceptor(axios, refreshToken, {
  statusCodes: [401, 403, 500]
});

export default async function() {
  try {
    axios.defaults.baseURL = APP_API_ENDPOINT;
    await setToken();
    createAuthRefreshInterceptor(axios, refreshToken, {
      statusCodes: [401, 403, 500]
    });
  } catch (err) {
    logger("error", "axios config error", err);
  }
}
